export const maxPdfFilenameBaseLength = 96;

const filenameExtensionPattern = /\.[A-Za-z0-9]{1,12}$/;

export function sanitizePdfFilename(input: unknown) {
  if (typeof input !== "string") {
    return "document.pdf";
  }

  const normalized = input
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\/\\]+/g, " ")
    .replace(/[\x00-\x1f\x7f]+/g, " ")
    .replace(/[<>:"|?*]+/g, " ")
    .trim()
    .replace(filenameExtensionPattern, "")
    .replace(/\.+/g, " ")
    .replace(/[^A-Za-z0-9 _-]+/g, " ")
    .replace(/[\s_]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, maxPdfFilenameBaseLength)
    .replace(/_+$/g, "");

  if (normalized.length === 0) {
    return "document.pdf";
  }

  return `${normalized}.pdf`;
}

export function buildPdfContentDisposition(input: unknown) {
  const filename = sanitizePdfFilename(input);

  return `attachment; filename="${filename}"`;
}
